import './Program_table.css';


const Portfolio = () => {




    return (

		<table border="0" cellPadding="0" cellSpacing="0" id="sheet0" className="sheet0 gridlines">
        <col className="col0"/>
        <col className="col1"/>
        <col className="col2"/>
        <col className="col3"/>
        <col className="col4"/>
        <col className="col5"/>
        <tbody>
          <tr className="row0">
            <td className="column0 style6 null"></td>
            <td className="column1 style6 null"></td>
            <td className="column2 style6 null"></td>
            <td className="column3 style6 null"></td>
            <td className="column4 style6 null"></td>
            <td className="column5 style6 null"></td>
          </tr>
          <tr className="row1">
            <td className="column0">&nbsp;</td>
            <td className="column1 style3 s">Date</td>
            <td className="column2 style3 s">Time</td>
            <td className="column3 style3 s">Events</td>
            <td className="column4 style3 s">Location</td>
            <td className="column5 style7 null"></td>
          </tr>
          <tr className="row2">
            <td className="column0">&nbsp;</td>
            <td className="column1">&nbsp;</td>
            <td className="column2">&nbsp;</td>
            <td className="column3">&nbsp;</td>
            <td className="column4">&nbsp;</td>
            <td className="column5">&nbsp;</td>
          </tr>
          <tr className="row3">
            <td className="column0 style6 null"></td>
            <td className="column1 style4 s">July 14th</td>
            <td className="column2 style4 s">13:00-18:00</td>
            <td className="column3 style4 s">Onsite Registration</td>
            <td className="column4 style4 s">Hotel Lobby</td>
            <td className="column5 style6 null"></td>
          </tr>
          <tr className="row4">
            <td className="column0 style6 null"></td>
            <td className="column1 style6 null"></td>
            <td className="column2 style6 null"></td>
            <td className="column3 style6 null"></td>
            <td className="column4 style6 null"></td>
            <td className="column5 style6 null"></td>
          </tr>
          <tr className="row5">
            <td className="column0 style6 null"></td>
            <td className="column1 style15 s style15" rowSpan="12">July 15th</td>
            <td className="column2 style4 s">08:30 - 08:45</td>
            <td className="column3 style4 s">Opening Ceremony</td>
            <td className="column4 style13 s style13" rowSpan="8">Athena Hall</td>
            <td className="column5 style6 null"></td>
          </tr>
          <tr className="row6">
            <td className="column0 style6 null"></td>
            <td className="column2 style4 s">08:45 - 09:30</td>
            <td className="column3 style4 s">Plenary Speech I</td>
            <td className="column5 style6 null"></td>
          </tr>
          <tr className="row7">
            <td className="column0 style6 null"></td>
            <td className="column2 style4 s">09:30 - 10:00</td>
            <td className="column3 style4 s">Invited Talk I</td>
            <td className="column5 style6 null"></td>
          </tr>
          <tr className="row8">
            <td className="column0 style6 null"></td>
            <td className="column2 style9 s">10:00 - 10:20</td>
            <td className="column3 style11 s">Photo Session &amp; <br />
Tea/Coffee Break</td>
            <td className="column5 style6 null"></td>
          </tr>
          <tr className="row10">
            <td className="column0 style6 null"></td>
            <td className="column2 style4 s">10:20 - 10:40</td>
            <td className="column3 style4 s">Best Paper Presentation</td>
            <td className="column5 style6 null"></td>
          </tr>
          {/* <tr className="row11">
            <td className="column0 style6 null"></td>
            <td className="column2 style4 s">10:40 - 11:00</td>
            <td className="column3 style4 s">Best Student Paper Presentation</td>
            <td className="column5 style6 null"></td>
          </tr> */}
          <tr className="row12">
            <td className="column0 style6 null"></td>
            <td className="column2 style10 s">10:40 - 11:00</td>
            <td className="column3 style12 s">Best Special Sessions<br />
&nbsp;Paper Presentation</td>
            <td className="column5 style6 null"></td>
          </tr>
          <tr className="row9">
            <td className="column0 style6 null"></td>
            <td className="column2 style4 s">11:00 - 12:00</td>
            <td className="column3 style4 s">Plenary Speech II</td>
            <td className="column5 style6 null"></td>
          </tr>
          <tr className="row13">
            <td className="column0 style6 null"></td>
            <td className="column2 style16 s style18" colSpan="3">Lunch Break</td>
            <td className="column5 style6 null"></td>
          </tr>
          <tr className="row14">
            <td className="column0 style6 null"></td>
            <td className="column2 style4 s">13:20 - 17:20</td>
            <td className="column3 style5 s">Parallel Sessions<br />
(Five parallel onsite/online oral sessions, please refer to the next page for detailed technical program schedule)</td>
            <td className="column4 style5 s">Athena Hall<br />
Poseidon Hall<br />
Gaia Hall<br />
Online Room 1<br />
Online Room 2</td>
            <td className="column5 style6 null"></td>
          </tr>
          <tr className="row15">
            <td className="column0 style6 null"></td>
            <td className="column2 style16 s style18" colSpan="3">Tea/Coffee Breaks for Parallel Sessions: 15:00-15:20</td>
            <td className="column5 style6 null"></td>
          </tr>
          <tr className="row16">
            <td className="column0 style6 null"></td>
            <td className="column2 style4 s">18:00 - 20:00</td>
            <td className="column3 style4 s">Award Banquet</td>
            <td className="column4 style4 s">Hall</td>
            <td className="column5 style6 null"></td>
          </tr>
          <tr className="row17">
            <td className="column0 style6 null"></td>
            <td className="column1 style6 null"></td>
            <td className="column2 style6 null"></td>
            <td className="column3 style6 null"></td>
            <td className="column4 style6 null"></td>
            <td className="column5 style6 null"></td>
          </tr>
          <tr className="row18">
            <td className="column0 style6 null"></td>
            <td className="column1 style19 s style21" rowSpan="3">July 16th</td>
            <td className="column2 style8 s">09:00 - 12:00</td>
            <td className="column3 style5 s">Parallel Sessions<br />
(Four parallel onsite/online oral sessions,please refer to the next page for detailed technical program schedule)</td>
            <td className="column4 style5 s">Athena Hall<br />
Poseidon Hall<br />
<br />
Online Room 1<br />
Online Room 2</td>
            <td className="column5 style6 null"></td>
          </tr>
          <tr className="row19">
            <td className="column0 style6 null"></td>
            <td className="column2 style22 s style27" colSpan="3" rowSpan="2">Tea/Coffee Breaks for Parallel Sessions: 10:00-10:20</td>
            <td className="column5 style6 null"></td>
          </tr>
          <tr className="row20">
            <td className="column0 style6 null"></td>
            <td className="column5 style6 null"></td>
          </tr>
          <tr className="row21">
            <td className="column0 style6 null"></td>
            <td className="column1 style4 s">July 17th/18th</td>
            <td className="column2 style4 null"></td>
            <td className="column3 style5 s">Post-event Activities and Tour<br />
(Free activities, self-pay, not officially organized)</td>
            <td className="column4 style4 null"></td>
            <td className="column5 style6 null"></td>
          </tr>
          <tr className="row22">
            <td className="column0 style6 null"></td>
            <td className="column1 style6 null"></td>
            <td className="column2 style6 null"></td>
            <td className="column3 style6 null"></td>
            <td className="column4 style6 null"></td>
            <td className="column5 style6 null"></td>
          </tr>
          <tr className="row23">
            <td className="column0 style6 null"></td>
            <td className="column1 style6 null"></td>
            <td className="column2 style6 null"></td>
            <td className="column3 style6 null"></td>
            <td className="column4 style6 null"></td>
            <td className="column5 style6 null"></td>
          </tr>
        </tbody>
    </table>
    )
}

export default Portfolio